export default (initialState = {}) => {
  return () => {
    return {
      po_applicable: false,
      po_file_applicable: false,
      role: "buyer",
      ...initialState,
    };
  };
};
